export default "__VITE_ASSET__86f4906b__"